import { toCSSPixel } from '../../utils/styles'
import { getModalContentFullScreenHeight } from '../Modal'

import {
  WYSIWYG_EDITOR_DEFAULT_MAX_HEIGHT,
  WYSIWYG_EDITOR_DEFAULT_MIN_HEIGHT,
  WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT,
} from './WysiwygEditor.constants'

// 0 outside a modal box, where the content has no fixed height
export function getWysiwygEditorFullScreenHeight({ content, editor, wrapper }) {
  if (!getModalContentFullScreenHeight(content)) {
    return 0
  }

  const wrapperHeight = wrapper.getBoundingClientRect().height
  const editorHeight = editor.container.getBoundingClientRect().height

  return Math.floor(content.clientHeight - (wrapperHeight - editorHeight))
}

export function getWysiwygEditorHeightLimits(editor) {
  return {
    maxHeight: editor.getParam(
      'max_height',
      WYSIWYG_EDITOR_DEFAULT_MAX_HEIGHT,
      'number'
    ),
    minHeight: editor.getParam(
      'min_height',
      WYSIWYG_EDITOR_DEFAULT_MIN_HEIGHT,
      'number'
    ),
  }
}

// `autoresize` reads the limits from `editor.settings` on every resize
export function setWysiwygEditorHeightLimits(editor, { maxHeight, minHeight }) {
  editor.settings.min_height = minHeight
  editor.settings.max_height = maxHeight
  editor.container.style.minHeight = toCSSPixel(minHeight)

  editor.fire(WYSIWYG_EDITOR_EVENT_RESIZE_CONTENT)
}
